import _toConsumableArray from "/Users/adrian/Documents/work/sp-lwowek/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/Users/adrian/Documents/work/sp-lwowek/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/Users/adrian/Documents/work/sp-lwowek/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/adrian/Documents/work/sp-lwowek/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Users/adrian/Documents/work/sp-lwowek/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/adrian/Documents/work/sp-lwowek/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/adrian/Documents/work/sp-lwowek/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/Users/adrian/Documents/work/sp-lwowek/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import "core-js/modules/es.promise.finally.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { GraphQLError as r, Kind as e, print as t, parse as a } from "graphql";
import { make as n } from "wonka";
var rehydrateGraphQlError = function rehydrateGraphQlError(e) {
  if (e instanceof r) {
    return e;
  } else if ("object" == typeof e && e.message) {
    return new r(e.message, e.nodes, e.source, e.positions, e.path, e, e.extensions || {});
  } else {
    return new r(e);
  }
};
var CombinedError = /*#__PURE__*/function (_Error) {
  _inherits(CombinedError, _Error);
  var _super = _createSuper(CombinedError);
  function CombinedError(r) {
    var _this;
    _classCallCheck(this, CombinedError);
    var e = (r.graphQLErrors || []).map(rehydrateGraphQlError);
    var t = function (r, e) {
      var t = "";
      if (r) {
        return "[Network] ".concat(r.message);
      }
      if (e) {
        var _iterator = _createForOfIteratorHelper(e),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var a = _step.value;
            if (t) {
              t += "\n";
            }
            t += "[GraphQL] ".concat(a.message);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return t;
    }(r.networkError, e);
    _this = _super.call(this, t);
    _this.name = "CombinedError";
    _this.message = t;
    _this.graphQLErrors = e;
    _this.networkError = r.networkError;
    _this.response = r.response;
    return _this;
  }
  _createClass(CombinedError, [{
    key: "toString",
    value: function toString() {
      return this.message;
    }
  }]);
  return CombinedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
var phash = function phash(r, e) {
  var t = "number" == typeof e ? 0 | e : 5381;
  for (var a = 0, n = 0 | r.length; a < n; a++) {
    t = (t << 5) + t + r.charCodeAt(a);
  }
  return t;
};
var o = new Set();
var i = new WeakMap();
var stringify = function stringify(r) {
  if (null === r || o.has(r)) {
    return "null";
  } else if ("object" != typeof r) {
    return JSON.stringify(r) || "";
  } else if (r.toJSON) {
    return stringify(r.toJSON());
  } else if (Array.isArray(r)) {
    var e = "[";
    var _iterator2 = _createForOfIteratorHelper(r),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var t = _step2.value;
        if ("[" !== e) {
          e += ",";
        }
        e += (t = stringify(t)).length > 0 ? t : "null";
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return e += "]";
  }
  var a = Object.keys(r).sort();
  if (!a.length && r.constructor && r.constructor !== Object) {
    var n = i.get(r) || Math.random().toString(36).slice(2);
    i.set(r, n);
    return "{\"__key\":\"".concat(n, "\"}");
  }
  o.add(r);
  var s = "{";
  var _iterator3 = _createForOfIteratorHelper(a),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var v = _step3.value;
      var f = stringify(r[v]);
      if (f) {
        if (s.length > 1) {
          s += ",";
        }
        s += stringify(v) + ":" + f;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  o.delete(r);
  return s += "}";
};
var stringifyVariables = function stringifyVariables(r) {
  o.clear();
  return stringify(r);
};
var s = /("{3}[\s\S]*"{3}|"(?:\\.|[^"])*")/g;
var v = /(#[^\n\r]+)?(?:\n|\r\n?|$)+/g;
var replaceOutsideStrings = function replaceOutsideStrings(r, e) {
  return e % 2 == 0 ? r.replace(v, "\n") : r;
};
var sanitizeDocument = function sanitizeDocument(r) {
  return r.split(s).map(replaceOutsideStrings).join("").trim();
};
var f = new Map();
var l = new Map();
var stringifyDocument = function stringifyDocument(r) {
  var e;
  if ("string" == typeof r) {
    e = sanitizeDocument(r);
  } else if (r.loc && l.get(r.__key) === r) {
    e = r.loc.source.body;
  } else {
    e = f.get(r) || sanitizeDocument(t(r));
    f.set(r, e);
  }
  if ("string" != typeof r && !r.loc) {
    r.loc = {
      start: 0,
      end: e.length,
      source: {
        body: e,
        name: "gql",
        locationOffset: {
          line: 1,
          column: 1
        }
      }
    };
  }
  return e;
};
var hashDocument = function hashDocument(r) {
  var e = phash(stringifyDocument(r));
  if ("object" == typeof r && "definitions" in r) {
    var t = getOperationName(r);
    if (t) {
      e = phash("\n# ".concat(t), e);
    }
  }
  return e;
};
var keyDocument = function keyDocument(r) {
  var e;
  var t;
  if ("string" == typeof r) {
    e = hashDocument(r);
    t = l.get(e) || a(r, {
      noLocation: !0
    });
  } else {
    e = r.__key || hashDocument(r);
    t = l.get(e) || r;
  }
  if (!t.loc) {
    stringifyDocument(t);
  }
  t.__key = e;
  l.set(e, t);
  return t;
};
var createRequest = function createRequest(r, e) {
  if (!e) {
    e = {};
  }
  var t = keyDocument(r);
  var a = stringifyVariables(e);
  var n = t.__key;
  if ("{}" !== a) {
    n = phash(a, n);
  }
  return {
    key: n,
    query: t,
    variables: e
  };
};
var getOperationName = function getOperationName(r) {
  var _iterator4 = _createForOfIteratorHelper(r.definitions),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var t = _step4.value;
      if (t.kind === e.OPERATION_DEFINITION && t.name) {
        return t.name.value;
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
};
var getOperationType = function getOperationType(r) {
  var _iterator5 = _createForOfIteratorHelper(r.definitions),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var t = _step5.value;
      if (t.kind === e.OPERATION_DEFINITION) {
        return t.operation;
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
};
var makeResult = function makeResult(r, e, t) {
  if (!("data" in e) && !("errors" in e) || "incremental" in e) {
    throw new Error("No Content");
  }
  var a = "subscription" === r.kind;
  return {
    operation: r,
    data: e.data,
    error: Array.isArray(e.errors) ? new CombinedError({
      graphQLErrors: e.errors,
      response: t
    }) : void 0,
    extensions: "object" == typeof e.extensions && e.extensions || void 0,
    hasNext: null == e.hasNext ? a : e.hasNext
  };
};
var mergeResultPatch = function mergeResultPatch(r, e, t) {
  var a;
  var n = !!r.extensions || !!e.extensions;
  var o = _objectSpread(_objectSpread({}, r.extensions), e.extensions);
  var i = r.error ? r.error.graphQLErrors : [];
  var s = e.incremental;
  if ("path" in e) {
    s = [{
      data: e.data,
      path: e.path
    }];
  }
  if (s) {
    a = _objectSpread({}, r.data);
    var _iterator6 = _createForOfIteratorHelper(s),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var v = _step6.value;
        if (Array.isArray(v.errors)) {
          i.push.apply(i, _toConsumableArray(v.errors));
        }
        if (v.extensions) {
          Object.assign(o, v.extensions);
          n = !0;
        }
        var f = v.path[0];
        var l = a;
        for (var u = 1, d = v.path.length; u < d; f = v.path[u++]) {
          l = l[f] = Array.isArray(l[f]) ? _toConsumableArray(l[f]) : _objectSpread({}, l[f]);
        }
        if (Array.isArray(v.items)) {
          var c = +f >= 0 ? f : 0;
          for (var p = 0, h = v.items.length; p < h; p++) {
            l[c + p] = v.items[p];
          }
        } else if (void 0 !== v.data) {
          l[f] = l[f] && v.data ? _objectSpread(_objectSpread({}, l[f]), v.data) : v.data;
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  } else {
    a = e.data || r.data;
  }
  return {
    operation: r.operation,
    data: a,
    error: i.length ? new CombinedError({
      graphQLErrors: i,
      response: t
    }) : void 0,
    extensions: n ? o : void 0,
    hasNext: !!e.hasNext
  };
};
var makeErrorResult = function makeErrorResult(r, e, t) {
  return {
    operation: r,
    data: void 0,
    error: new CombinedError({
      networkError: e,
      response: t
    }),
    extensions: void 0
  };
};
function makeFetchBody(r) {
  return {
    query: stringifyDocument(r.query),
    operationName: getOperationName(r.query),
    variables: r.variables || void 0,
    extensions: void 0
  };
}
var makeFetchURL = function makeFetchURL(r, e) {
  var t = "query" === r.kind && r.context.preferGetMethod;
  if (!t || !e) {
    return r.context.url;
  }
  var a = new URL(r.context.url);
  var n = a.searchParams;
  if (e.operationName) {
    n.set("operationName", e.operationName);
  }
  if (e.query) {
    n.set("query", e.query);
  }
  if (e.variables) {
    n.set("variables", stringifyVariables(e.variables));
  }
  if (e.extensions) {
    n.set("extensions", stringifyVariables(e.extensions));
  }
  var o = a.toString();
  if (o.length > 2047 && "force" !== t) {
    r.context.preferGetMethod = !1;
    return r.context.url;
  }
  return o;
};
var makeFetchOptions = function makeFetchOptions(r, e) {
  var t = "query" === r.kind && !!r.context.preferGetMethod;
  var a = {
    accept: "multipart/mixed, application/graphql-response+json, application/graphql+json, application/json"
  };
  if (!t) {
    a["content-type"] = "application/json";
  }
  var n = ("function" == typeof r.context.fetchOptions ? r.context.fetchOptions() : r.context.fetchOptions) || {};
  if (n.headers) {
    for (var o in n.headers) {
      a[o.toLowerCase()] = n.headers[o];
    }
  }
  return _objectSpread(_objectSpread({}, n), {}, {
    body: !t && e ? JSON.stringify(e) : void 0,
    method: t ? "GET" : "POST",
    headers: a
  });
};
var u = "undefined" != typeof TextDecoder ? new TextDecoder() : null;
var d = /content-type:[^\r\n]*application\/json/i;
var c = /boundary="?([^=";]+)"?/i;
var makeFetchSource = function makeFetchSource(r, e, t) {
  var a = "manual" === t.redirect ? 400 : 300;
  var o = r.context.fetch;
  return n(function (_ref) {
    var n = _ref.next,
      i = _ref.complete;
    var s = "undefined" != typeof AbortController ? new AbortController() : null;
    if (s) {
      t.signal = s.signal;
    }
    var v = !1;
    var executeIncrementalFetch = function executeIncrementalFetch(r, e, t) {
      var a = t.headers && t.headers.get("Content-Type") || "";
      if (/text\//i.test(a)) {
        return t.text().then(function (a) {
          r(makeErrorResult(e, new Error(a), t));
        });
      } else if (!/multipart\/mixed/i.test(a)) {
        return t.text().then(function (a) {
          r(makeResult(e, JSON.parse(a), t));
        });
      }
      var n = "---";
      var o = a.match(c);
      if (o) {
        n = "--" + o[1];
      }
      var i;
      var cancel = function cancel() {};
      if (t[Symbol.asyncIterator]) {
        var s = t[Symbol.asyncIterator]();
        i = s.next.bind(s);
      } else if ("body" in t && t.body) {
        var f = t.body.getReader();
        cancel = function cancel() {
          return f.cancel();
        };
        i = function i() {
          return f.read();
        };
      } else {
        throw new TypeError("Streaming requests unsupported");
      }
      var l = "";
      var p = !0;
      var h = null;
      var y = null;
      return i().then(function next(a) {
        if (!a.done) {
          var o = "Buffer" === (w = a.value).constructor.name ? w.toString() : u.decode(w);
          var s = o.indexOf(n);
          if (s > -1) {
            s += l.length;
          } else {
            s = l.indexOf(n);
          }
          l += o;
          while (s > -1) {
            var f = l.slice(0, s);
            var c = l.slice(s + n.length);
            if (p) {
              p = !1;
            } else {
              var x = f.indexOf("\r\n\r\n") + 4;
              var m = f.slice(0, x);
              var g = f.slice(x, f.lastIndexOf("\r\n"));
              var b = void 0;
              if (d.test(m)) {
                try {
                  b = JSON.parse(g);
                  h = y = y ? mergeResultPatch(y, b, t) : makeResult(e, b, t);
                } catch (r) {}
              }
              if ("--" === c.slice(0, 2) || b && !b.hasNext) {
                if (!y) {
                  return r(makeResult(e, {}, t));
                }
                break;
              }
            }
            s = (l = c).indexOf(n);
          }
        } else {
          v = !0;
        }
        var w;
        if (h) {
          r(h);
          h = null;
        }
        if (!a.done && (!y || y.hasNext)) {
          return i().then(next);
        }
      }).finally(cancel);
    };
    var f = !1;
    var l = !1;
    var p;
    Promise.resolve().then(function () {
      if (f) {
        return;
      }
      return (o || fetch)(e, t);
    }).then(function (e) {
      if (!e) {
        return;
      }
      l = (p = e).status < 200 || p.status >= a;
      return executeIncrementalFetch(n, r, p);
    }).then(i).catch(function (e) {
      if (v) {
        throw e;
      }
      var t = makeErrorResult(r, l ? p.statusText ? new Error(p.statusText) : e : e, p);
      n(t);
      i();
    });
    return function () {
      f = !0;
      if (s) {
        s.abort();
      }
    };
  });
};
export { CombinedError as C, makeErrorResult as a, makeFetchBody as b, makeFetchURL as c, makeFetchOptions as d, makeFetchSource as e, createRequest as f, getOperationType as g, stringifyVariables as h, mergeResultPatch as i, getOperationName as j, keyDocument as k, makeResult as m, stringifyDocument as s };